import { Box, Container, Stack } from '@mui/material';
import { DeliveryStatus } from '@synergy/models';
import { ReactElement } from 'react';

import { ArticleDetailDeliveryActions } from './components/article-detail-delivery-actions';
import { ArticleDetailDescriptionAccordion } from './components/article-detail-description-accordion';
import { ArticleDetailPackingUnits } from './components/article-detail-packing-units';
import { ArticleDetailPreviewImageMobile } from './components/article-detail-preview-image-mobile';
import { ArticleDetailPriceContainer } from './components/article-detail-price-container';
import { ArticleDetailScalePrices } from './components/article-detail-scale-prices';
import { ArticleDetailSupplierConditions } from './components/article-detail-supplier-conditions';
import { ArticleDetailSupplierImage } from './components/article-detail-supplier-image';
import { ArticleDetailTitle } from './components/article-detail-title';
import { ArticleDetailVariants } from './components/article-detail-variants';
import { useArticleDetailContext } from './article-detail';

export const ArticleDetailMobile = (): ReactElement | null => {
    const { article } = useArticleDetailContext();
    const { scalePrices, variants, deliveryStatus, packingUnits } = article;

    return (
        <Container maxWidth="sm" sx={{ mt: 3, mb: 6 }}>
            <Stack gap={6}>
                <Box>
                    <Stack gap={2.5} mb={2}>
                        <ArticleDetailTitle />
                        <ArticleDetailPreviewImageMobile />
                    </Stack>
                    <Stack gap={1.5}>
                        <ArticleDetailPriceContainer />
                        <ArticleDetailSupplierImage />
                    </Stack>
                </Box>
                <Stack gap={4}>
                    {deliveryStatus !== DeliveryStatus.OnRequest && scalePrices.length > 0 && (
                        <Stack>
                            <ArticleDetailScalePrices />
                        </Stack>
                    )}
                    {packingUnits.length > 0 && (
                        <Stack>
                            <ArticleDetailPackingUnits />
                        </Stack>
                    )}
                    {variants.length > 0 && <ArticleDetailVariants />}
                    <Stack gap={1.5}>
                        <ArticleDetailDeliveryActions />
                    </Stack>
                </Stack>
                <ArticleDetailSupplierConditions />
                <ArticleDetailDescriptionAccordion />
            </Stack>
        </Container>
    );
};
